import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { AirportListItem } from '../../../../../../components/SearchForm/components/AirportsWidget/components/AirportListItem.js';
import { Caption } from '../../../../../../components/SearchForm/components/AirportsWidget/components/Caption.js';
import { CityList } from '../../../../../../components/SearchForm/components/AirportsWidget/components/Region/components/CityList.js';
import { Accordion, Checkbox, LabelMediumBold, LabelXSmall, Stack } from '../../../../../../primitives/index.js';
import { SPACING_NONE, SPACING_SMALL } from '../../../../../../utils/spacingLegacy.js';
export const Region = ({
  item,
  isChecked,
  onCheck,
  onCheckboxClick,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  return _jsxs(Stack, {
    divider: true,
    children: [_jsx(Stack, {
      spacing: SPACING_NONE,
      children: item.subRegions.map((subItem, index) => _jsx(Accordion, {
        withoutBorder: true,
        caption: _jsxs(Caption, {
          direction: "row",
          alignItems: "center",
          spacing: SPACING_NONE,
          children: [_jsx(Checkbox, {
            checked: isChecked(subItem.subRegion),
            value: subItem.subRegion,
            onChange: onChange,
            onClick: onCheckboxClick
          }), _jsxs(Stack, {
            direction: "row",
            alignItems: "center",
            children: [_jsx(LabelMediumBold, {
              children: t(`airportsWidget:options.${subItem.subRegion}.name`)
            }), _jsx(CityList, {
              truncate: true,
              color: 'contentTertiary',
              children: subItem.airports?.map(airport => t(`airportsWidget:options.${airport}.name`)).join(', ')
            })]
          })]
        }),
        children: subItem.airports?.map((code, index) => _jsx(AirportListItem, {
          children: _jsx(Checkbox, {
            value: code,
            checked: isChecked(code),
            label: _jsxs(Stack, {
              direction: "row",
              alignItems: "baseline",
              spacing: "small",
              children: [t(`airportsWidget:options.${code}.name`), _jsx(LabelXSmall, {
                truncate: true,
                color: 'contentTertiary',
                children: code
              })]
            }),
            onChange: onCheck
          }, index)
        }, index))
      }, index))
    }), _jsx(Stack, {
      spacing: SPACING_NONE,
      children: item.airports?.sort((a, b) => t(`airportsWidget:options.${a}.name`).localeCompare(t(`airportsWidget:options.${b}.name`))).map((airport, index) => _jsx(Stack, {
        children: _jsx(Checkbox, {
          value: airport,
          checked: isChecked(airport),
          label: _jsxs(Stack, {
            direction: "row",
            alignItems: "baseline",
            spacing: SPACING_SMALL,
            children: [t(`airportsWidget:options.${airport}.name`), _jsx(LabelXSmall, {
              truncate: true,
              color: 'contentTertiary',
              children: airport
            })]
          }),
          onChange: onCheck
        }, index)
      }, index))
    }, item.region)]
  });
};